// extracted by mini-css-extract-plugin
export default {"pageContainer":"Style_pageContainer__MUUyu","cardContainer":"Style_cardContainer__xbBT4","truncateTitle":"Style_truncateTitle__9npu8","avatar":"Style_avatar__FHnsK"};